import Bullet from "./Bullet";
import BulletButton from "./BulletButton";

export default ({
  active = false,
  children = [],
  prefix,
  suffix,
  onClick = () => {},
}: any) => {
  return (
    <BulletButton active={active} onClick={onClick}>
      {prefix ? <span>${prefix}</span> : <></>}
      <Bullet>{children}</Bullet>
      {suffix ? <span>{suffix}</span> : <></>}
    </BulletButton>
  );
};
